import { BasePrescriptionTemplate } from './BasePrescriptionTemplate';
import type { PrescriptionPrintTemplateProps } from '../types';

const extractDermatologySummary = (specialtyData: Record<string, unknown> | null): string | null => {
  if (!specialtyData) return null;

  const dermatology = specialtyData.dermatologia;
  if (!dermatology || typeof dermatology !== 'object') return null;

  const careNotes = (dermatology as { skin_care_plan?: unknown }).skin_care_plan;
  if (typeof careNotes !== 'string' || careNotes.trim() === '') return null;

  return `Dermatología: plan de cuidado cutáneo - ${careNotes.trim()}.`;
};

export function DermatologyPrescriptionTemplate(props: PrescriptionPrintTemplateProps) {
  const dermatologySummary = extractDermatologySummary(props.specialtyData);

  if (!dermatologySummary) {
    return <BasePrescriptionTemplate {...props} />;
  }

  const mergedRecommendations = props.consultation.general_recommendations
    ? `${dermatologySummary}\n${props.consultation.general_recommendations}`
    : dermatologySummary;

  return (
    <BasePrescriptionTemplate
      {...props}
      consultation={{
        ...props.consultation,
        general_recommendations: mergedRecommendations,
      }}
    />
  );
}
